// onboarding — Pierwsze kroki (Onboarding.tsx + OnboardingView.tsx).
// Projekt: Claude Design, sesja 37, artboardy 07a–09d. Klucze lustrzane z ../en/onboarding.ts.
//
// Każdy krok tego kreatora wykonuje PRAWDZIWĄ operację backendu, więc copy wolno mówić
// w czasie teraźniejszym o rzeczach, które naprawdę się dzieją. Druga reguła: żadna liczba
// na ekranie nie jest stałą — saldo, cena editu, limity pliku, liczba słów, BPM i procent
// renderu przychodzą z backendu i wchodzą tu przez {placeholdery}.
//
// Trzecia reguła, nowa w paczce 37 (zasada 8 planu): wiersz liczb zamiast zdania o saldzie.
// „Masz {n} tokenów. Edit kosztuje {k}.” było zdaniem o dwóch liczbach — teraz to dwa wiersze
// etykieta + liczba, a zdania nie ma. Tak samo odeszły: wstęp i lista trzech obietnic ekranu
// startowego, zdanie o niezamykaniu strony przy wysyłce, zdanie o czasie analizy, zdanie
// o zamykaniu strony w trakcie renderu, blok „w międzyczasie” ekranu oczekiwania i końcowe
// zdania ekranu „gotowe”.
export const onboarding = {
  stepOf: 'Krok {n} z 3',
  skip: 'Pomiń',
  // Paczka N2 (N0): zapis „przeszedłem Pierwsze kroki” na koncie się nie udał. Ekran
  // NIE nawiguje — strażnik `FirstRunGate` odbiłby z powrotem tutaj, a ten ekran stoi
  // poza powłoką, więc konto zostawałoby zamknięte w pętli bez jednego odnośnika.
  exitFailed: {
    title: 'Nie zapisaliśmy końca Pierwszych kroków',
    chip: 'Nie zapisano',
    body: 'Konto dalej ma Pierwsze kroki przed sobą. Nic nie przepadło.',
    retry: 'Spróbuj ponownie',
  },
  // Ten sam link na ekranie końcowym: nie ma już czego pomijać.
  close: 'Zamknij',

  // Wiersze liczb (artboardy 07a, 08a, 08c, 08d). Etykiety, nie zdania.
  nums: {
    have: 'Masz',
    cost: 'Koszt',
    missing: 'Brakuje',
    edit: 'Edit',
    after: 'Zostanie',
    before: 'Było',
    now: 'Jest',
    none: '-',
  },

  // 09a · Konto czeka — krok W Pierwszych krokach, nie osobny panel.
  pending: {
    title: 'Sprawdzamy konto',
    step1: 'Wgraj utwór',
    step2: 'Wybierz klipy i styl',
    step3: 'Pobierz MP4',
    // Tytuł (tooltip) wyłączonych przycisków wgrywania i renderu dla konta pending.
    locked: 'Odblokuje się po zatwierdzeniu konta',
  },

  // 07a · Start.
  welcome: {
    title: 'Zaczynamy',
    // Czynność, nie echo nagłówka. Bez kosztu w etykiecie: na starcie ta akcja
    // prowadzi do wgrywania i nic nie kosztuje (R2, rozstrzygnięcie punktu 51).
    cta: 'Zrób pierwszy edit',
    loading: 'Sprawdzam saldo i cennik…',
    error: 'Nie udało się pobrać cennika. Odśwież stronę - bez cen nie zaczynamy.',
  },

  // 07b–07g · Krok 1: wgrywanie, jego błędy, analiza.
  step1: {
    title: 'Wgraj utwór',
    cta: 'Wgraj utwór',
    drop: 'Upuść plik tutaj',
    // {exts} i {limit} z /api/render/config; zanim przyjdą — sama lista bez limitu.
    formats: '{exts} · do {limit}',
    formatsUnknown: 'mp3, wav, flac, m4a',
    cancel: 'Przerwij',
    cancelled: 'Wysyłanie przerwane. Nic nie pobrano z konta.',
    retry: 'Spróbuj ponownie',
    // 07d · jeden blok: pigułka, jedno zdanie, kod operacji, dwie drogi.
    err: {
      chip: 'nie wgrano',
      tooLarge: 'Ten plik ma {size}, a limit to {limit}. Nic nie pobrano z konta.',
      type: 'Format .{ext} nie jest obsługiwany. Obsługiwane: {allowed}. Nic nie pobrano z konta.',
      dupChip: 'ten utwór już jest',
      dup: 'Ten sam plik jest już w Twojej Muzyce jako „{name}”. Nic nie pobrano z konta.',
      quota: 'Utwory w analizie: {pending} (limit: {limit}). Nic nie pobrano z konta.',
      long: 'Ten utwór jest dłuższy, niż przyjmujemy ({limit}). Nic nie pobrano z konta.',
      other: 'Nie udało się wgrać pliku. Nic nie pobrano z konta.',
      pick: 'Wybierz inny plik',
      useExisting: 'Użyj istniejącego utworu',
    },
    // 07e/07f · analiza: dwa wiersze, bez procentów (R2, punkt 6).
    analyzing: {
      words: 'Słowa',
      // Rodzina liczby mnogiej: 1 słowo / 2 słowa / 5 słów — liczba rządzi rzeczownikiem,
      // a w polskim wiadro zależy od liczby (bramka `locales-parity`).
      wordsDone: '{count} słów',
      wordsDone_one: '{count} słowo',
      wordsDone_few: '{count} słowa',
      wordsDone_many: '{count} słów',
      wordsPending: 'jeszcze się liczą…',
      beats: 'Rytm',
      beatsPending: 'jeszcze się liczy…',
      bpm: '{bpm} BPM',
      // Pigułka zamiast zdania „Bez słów w utworze. To nie błąd." (zasada 8).
      instrumental: 'bez słów',
      next: 'Dalej',
    },
    // 07g · analiza zawiodła — nazwana, nie schowana pod „w toku".
    analysisFailed: {
      title: 'Analiza się nie udała',
      chip: 'nie policzono',
      body: 'Nie odczytaliśmy tekstu z tego pliku. Nic nie pobrano z konta.',
      retry: 'Ponów analizę',
    },
  },

  // 08a–08c, 08g · Krok 2: paczki, styl, koszt; niedobór tokenów; pusta lista paczek.
  step2: {
    title: 'Wybierz klipy i styl',
    packs: 'Paczka klipów',
    clips: '{count} klipów',
    clips_one: '{count} klip',
    clips_few: '{count} klipy',
    clips_many: '{count} klipów',
    style: 'Styl',
    changeStyle: 'Zmień styl',
    stylePick: 'Wybierz',
    styleCancel: 'Anuluj',
    buy: 'Doładuj tokeny',
    // Etykieta akcji płatnej: koszt jest CZĘŚCIĄ etykiety, nie osobnym zdaniem.
    cta: 'Zrób pierwszy edit',
    // Słowo stanu na wyłączonym kaflu, to samo co w kroku 2 Generatora.
    noClips: 'bez użytecznych klipów',
    // 08g · pusta lista paczek systemowych, wzorzec błędu z 07d.
    noPacks: 'Nie mamy teraz gotowych paczek. Wgraj własny materiał w Bibliotece, w zakładce Klipy.',
    noPacksCode: 'packs-0',
    openClips: 'Otwórz Klipy',
    retry: 'Spróbuj ponownie',
    startFailed: 'Nie udało się rozpocząć renderu. Tokeny zostały na koncie.',
    noTokens: 'Za mało tokenów na ten edit. Dokup pakiet w Rozliczeniach.',
  },

  // 09b · Płatności chwilowo wyłączone (GATE 3) — okno nad krokiem 2.
  gate3: {
    title: 'Płatności są chwilowo wyłączone',
    ok: 'Rozumiem',
    contact: 'Napisz do nas',
  },

  // 08d · Krok 3 — kolejka i render mają JEDNO słowo (reguła 30: „renderuje się”
  // znika z pigułek w całym produkcie; kafel pokazuje postęp, pigułka mówi stan).
  step3: {
    chipQueued: 'w kolejce',
    chipRendering: 'w kolejce',
  },

  // 08f · Gotowe.
  done: {
    title: 'Masz pierwszy edit',
    download: 'Pobierz MP4',
  },

  // 08e · Render nie wyszedł.
  failed: {
    title: 'Render się nie udał',
    retry: 'Spróbuj ponownie',
    otherPack: 'Wybierz inne klipy',
  },
}
